/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationSuggestionResponse } from './';
import {
    OrganizationSuggestionResponseFromJSON,
    OrganizationSuggestionResponseFromJSONTyped,
    OrganizationSuggestionResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationSuggestionsResponse
 */
export interface OrganizationSuggestionsResponse {
    /**
     * 
     * @type {Array<OrganizationSuggestionResponse>}
     * @memberof OrganizationSuggestionsResponse
     */
    suggestions: Array<OrganizationSuggestionResponse>;
}

/**
 * Check if a given object implements the OrganizationSuggestionsResponse interface.
 */
export function instanceOfOrganizationSuggestionsResponse(value: object): value is OrganizationSuggestionsResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function OrganizationSuggestionsResponseFromJSON(json: any): OrganizationSuggestionsResponse {
    return OrganizationSuggestionsResponseFromJSONTyped(json, false);
}

export function OrganizationSuggestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSuggestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(OrganizationSuggestionResponseFromJSON)),
    };
}

export function OrganizationSuggestionsResponseToJSON(value?: OrganizationSuggestionsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map((v) => OrganizationSuggestionResponseToJSON(v))),
    };
}

